namespace Gordic.Epk.WebControls.Vyrizeni {

    interface IEpkConfigCompletition {
        cnt: GContentType<GEpkDbParamsNew>,
        def,
        guid,
        signConfig,
        ixp,
        ixb
    }

    //#region *** SIGNER ***

    export class Signer {

        private server = new GContent("Gordic.Epk.WebControls.Vyrizeni");
        private fileServiceProvider = new GContent("Gordic.Gui.WebControls.GFileServiceProvider");

        /**
         * podepsat v epk
         */
        public sign(configsToSign: Wfl.Interface.GEpkSignConfigDto[] | null | undefined, customConfig: GEpkSignOpt, signer: GEpkSigner, certInfo: CertInfo, glog?: Wfl.WebClient.GSettlementLog) {

            // pokud je počet configů k podepsání 0, musím reject, jinak dojde k podepsání prázdného souboru
            if (configsToSign == null || configsToSign.length === 0) {
                var responseText = "jres:32000478";//RC 32000478 : Nejsou k dispozici žádné soubory k podepsání.
                return $.Deferred().reject({ reason: responseText, handled: false, type: EReasonType.serverError }).promise();
            }

            var defForeach;
            var defStart = $.Deferred();
            var defEnd = $.Deferred();

            var signedConfigs: any[] = [];
            for (let i = 0; i < configsToSign.length; i++) {
                var prevPromise = i === 0 ? defStart : defForeach;
                let config = configsToSign[i];
                defForeach = prevPromise.then(() => {

                    if (glog != null) {
                        var textLog = String.Format("Signer.ts - File: {0} will be signed.", config.fileName!);
                        glog.writeLog(textLog);
                    }

                    return signer
                        .sign({
                            otherPswd: certInfo.otherPswd,
                            file: config.guid,
                            signTime: new Date(),
                            signWithTimeStamp: customConfig.casoveRazitko,
                            fileName: config.fileName,
                            idSigningReason: config.IxsDpo!,
                            certChain: certInfo!.certChain,
                            typeCert: certInfo!.typeCert!,
                            thumbprint: certInfo!.thumbprint,
                            showPswdDlg: certInfo.otherPswd == null || certInfo.otherPswd === "" ? false : true
                        }, {
                            VisualSignCount: config.VisualSignCount,
                            cardView: true,
                            ixsUlo: config.IxsUlo,
                            IsConverted: config.IsConverted,
                            guid: config.guid,
                            ElDocumentType: config.ElDocumentType,
                            Ixp: config.Ixp!,
                            Ixb: config.Ixb!,
                            SerCisloEpk: customConfig.serCisloEpk,
                            async: customConfig.async
                        })
                        .then((res: any) => { // Gordic.Wfl.WebClient.GSignatureResultDtoWithGuids
                            // push podepsaného configu do pole
                            var sgnConfig = {
                                reason: res.errorMsg,
                                success: true,
                                guid: (res.guid as string),
                                fileName: res.fileName,
                                IxsUlo: res.ixsUlo,
                                IsConverted: res.IsConverted,
                                IsSigned: true,
                                externalSignatureGuid: res.externalSignatureGuid,
                                externalTimestampGuid: res.externalTimestampGuid
                            };
                            signedConfigs.push(sgnConfig);

                            if (glog != null) {
                                var textLog = String.Format("File: {0} was signed.", res.fileName);
                                glog.writeLog(textLog);
                            }

                            return $.Deferred().resolve().promise();
                        });

                });
            }

            defStart.resolve();
            defForeach.then(() => {
                defEnd.resolve(signedConfigs);
            },
                (reason) => {
                    defEnd.reject(reason);
                })

            return defEnd.promise();

        }

        /**
         * vyvolání delegátu pro umístění podpisu (zavolán před podepsáním)
         */
        public finalizeConfigDelegate(_cnt: any, signer: GEpkSigner, MultiSettlement: boolean, customLogger?: Gordic.Diagnostics.GLog) {

            var cnt: GContentType<GEpkDbParamsNew> = _cnt;
             //Pozice obrázku doplněného po přidání el. podpisu (např. do PDF)
             //Pokud není 0, zapne se umísťovací komponenta 
             //Vizuální umístění podpisu
             //1- Ano, 2- Ano, včetně příloh
            if (cnt.EpkParams.epk_povumipod === 0 || cnt.EpkParams.gin_pdf_pictpos === 0) {
                if (customLogger != null)
                    customLogger.info("Vizuální umístění není povoleno kvůli DB parametrům - epk_povumipod === 0 || cnt.EpkParams.gin_pdf_pictpos === 0");
                return;
            }

            signer.finalizeConfigDelegate = (config: any/*Wfl.Interface.GWflSignCreateConfig*/, customDto: any) => {

                if (customLogger != null)
                    customLogger.info("StartFinalizeConfigDelegate");

                var extension = "";
                if (config.FileToSign != null && config.FileToSign.Extension != null) {
                    extension = config.FileToSign.Extension;
                    if (customLogger != null)
                        customLogger.info("FileToSignExtension = {0}", extension);
                }

                // parametry
                config.Ixp = customDto.Ixp;
                config.SerCisloEpk = customDto.SerCisloEpk;
                config.Ixb = customDto.Ixb; // thazmuka (31.3.2022) - doplnění Ixb pro nalezení vizuálního podpisu
                config["guid"] = customDto.guid;
                config["ixsUlo"] = customDto.ixsUlo;
                config.ElDocumentType = customDto.ElDocumentType;
                // příznak hromadného vyřízení
                customDto.MultiSettlement = MultiSettlement;

                if (extension.toLowerCase() !== ".pdf") {
                    const def = $.Deferred();
                    console.log("Nelze umístit podpis do souboru, který není pdf.");
                    //info: musí se provést kompletace podpisu, jinak to padalo (31.1.2023) thazmuka
                    this.epkConfigCompletition({ cnt: cnt, def: def, guid: customDto.guid, signConfig: config, ixp: config.Ixp, ixb: config.Ixb });
                    return def.promise();
                }

                // pro přílohy nekontrolovat umístění, protože zatim nastaveno neni
                setSignaturePositionsConsoleLog("CheckForBindedVisualSignPositionWithConfig", config);
                if (customLogger != null)
                    customLogger.info("CheckForBindedVisualSignPositionWithConfig");

                return Gordic.Wfl.AttachmentUtils.CheckForBindedVisualSignPositionWithConfig(config)
                    .then((signatureConfig: any) => {
                        // doplnění parametrů
                        signatureConfig["guid"] = customDto.guid;
                        signatureConfig["ixsUlo"] = customDto.ixsUlo;
                        signatureConfig.ElDocumentType = customDto.ElDocumentType;
                        setSignaturePositionsConsoleLog("SignPlacing", config);
                        if (customLogger != null)
                            customLogger.info("SignPlacing");
                        return this.signPlacing(cnt, signatureConfig, customDto, customLogger);
                    }).then((preparedConfig: Gordic.Wfl.Interface.GWflSignCreateConfig) => {
						config.DataPreparedForDistributedSignature = null;
                        if (preparedConfig.DistributedSignature) {
                            preparedConfig.FileData = null;
                            preparedConfig.FileToSign = null;
                        }
                        setSignaturePositionsConsoleLog("EndFinalizeConfigDelegate", preparedConfig);
                        if (customLogger != null)
                            customLogger.info("EndFinalizeConfigDelegate");
                        return $.Deferred().resolve(preparedConfig).promise();
                    });

            };

        }

        /**
         * otevření komponenty umístění podpisu a vložení podpisu
        */
        private signPlacing(_cnt: any, config: Gordic.Wfl.Interface.GWflSignCreateConfig, customDto: any, customLogger?: Gordic.Diagnostics.GLog) {

            var cnt: GContentType<GEpkDbParamsNew> = _cnt;
            var def = $.Deferred();
            var guid: string = (config as any).guid;
            // typ dokumentu
            var ElDocumentType = config.ElDocumentType;

            if (this.validateSignaturePositions(config) === true) {

                if (customLogger != null)
                    customLogger.info("validateSignaturePositions=true");

                // smazání
                config.DataPreparedForDistributedSignature = null;
                if (config.DistributedSignature && config.FileToSign != null) {
                    config.FileToSign.FileData = null;
                    config.FileToSign.FilePath = null;
                }
                this.epkConfigCompletition({ cnt: cnt, def: def, guid: guid, signConfig: config, ixp: config.Ixp, ixb: config.Ixb });
            }
            else {

                if (customLogger != null)
                    customLogger.info("validateSignaturePositions=false");

                // thazmuka (29.4.2022) - podmínka na nepovolené umístění vizuálního podpisu
                if (config.VisualSignConfig == null) {
                    console.log("V tomto případě není umístění podpisu povoleno.");
                    //return def.resolve(config);
                    this.epkConfigCompletition({ cnt: cnt, def: def, guid: guid, signConfig: config, ixp: config.Ixp, ixb: config.Ixb });
                    return def.promise();
                }

                // 1 - Ano, pouze obraz 
                if (cnt.EpkParams.epk_povumipod === 1) {
                    // není to obraz
                    if (ElDocumentType !== 0) {
                        console.log("V tomto případě lze umístit podpis pouze do souboru typu obraz.");
                        //return def.resolve(config);
                        this.epkConfigCompletition({ cnt: cnt, def: def, guid: guid, signConfig: config, ixp: config.Ixp, ixb: config.Ixb });
                        return def.promise();
                    }
                }
                // 2 - Ano, včetně příloh
                else if (cnt.EpkParams.epk_povumipod === 2) {
                    // v tomto případě se můžeme pokusit umístit podpis do všech souborů, které příjdou
                }
                else {
                    console.log("V tomto případě není umístění podpisu povoleno.");
                    //return def.resolve(config);
                    this.epkConfigCompletition({ cnt: cnt, def: def, guid: guid, signConfig: config, ixp: config.Ixp, ixb: config.Ixb });
                    return def.promise();
                }

                // thazmuka (9.8.2021)
                // v případě hromadného vyřízení není povolena možnost umístění VP
                if (customDto.MultiSettlement === true || customDto.async === true) {
                    if (customLogger != null)
                        customLogger.info("V případě hromadného vyřízení není povolena možnost umístění VP");
                    console.log("V případě hromadného vyřízení není povolena možnost umístění VP");
                       //return def.resolve(config);

                    this.epkConfigCompletition({ cnt: cnt, def: def, guid: guid, signConfig: config, ixp: config.Ixp, ixb: config.Ixb });
                    return def.promise();
                }

                //#region ** doplnění informací do configu **

                // verze s guid
                var source: Wfl.Interface.GWflFilePreviewSource = config.ElDocumentType === 0 ? Wfl.Interface.GWflFilePreviewSource.ElDocTemp : Wfl.Interface.GWflFilePreviewSource.AttachmentTemp;
                if(guid == null)
                    source = config.ElDocumentType === 0 ? Wfl.Interface.GWflFilePreviewSource.ElDoc : Wfl.Interface.GWflFilePreviewSource.Attachment;

                config.Ixp = customDto.Ixp;
                config.Ixb = customDto.Ixb;
                setSignaturePositionsConsoleLog("WflSignPlacing", config);

                if (customLogger != null)
                    customLogger.info("StartGWflSignPlacing");

                this.server.call("GetFileDto", { Guid: guid, VisualSignConfig: config.VisualSignConfig })
                    .then((Dto: Gordic.Wfl.Interface.GEpkFileDtoWithVisualSignConfig) => {

                        let SignaturePositionsTemp: Gordic.Security.Service.GPdfVisualSignPositionDto[] | null = null;

                        if (Dto.VisualSignConfig != null) {
                            config.VisualSignConfig = Dto.VisualSignConfig; // doplnění o občerstvené pozice
                            SignaturePositionsTemp = JSON.parse(JSON.stringify(Dto.VisualSignConfig.SignaturePositions))
                        }

                        if (Dto.Data != null)
                            config["FileData"] = Dto.Data;  // doplnění dat o samotném souboru


                        cnt.navigate(Gordic.Wfl.WebClient.GWflSignPlacing, {
                            data: { guid: guid, ixp: config.Ixp, ixb: config.Ixb, signCreateConfig: config, source: source }
                        } as Wfl.WebClient.IGWflSigSelectInput).on("contentclosed", (ev, ctx: Gordic.Wfl.Interface.GWflSignCreateConfig) => {

                            if (ctx == null) {
                                //RC 32000405 : Podepisování bylo při výběru vizuálního umístění podpisu přerušeno.
                                def.reject({ reason: "jres:32000405", handled: false, type: EReasonType.common }).promise();
                            }
                            else {

                                // situace, kdy na vstupu máme vizuální pozice a na výstup je vizuální umístění smazáno
                                if (ctx.VisualSignConfig != null &&
                                    ctx.VisualSignConfig.SignaturePositions != null &&
                                    ctx.VisualSignConfig.SignaturePositions.length === 0) {

                                    if (SignaturePositionsTemp != null) {
                                        ctx.VisualSignConfig.SignaturePositions = SignaturePositionsTemp;    // doplním původní pozice
                                    }
                                }

                                //#region -- smazání --
                                ctx.DataPreparedForDistributedSignature = null;
                                if (ctx.FileToSign != null) {
                                    ctx.FileToSign.FileData = null;
                                    ctx.FileToSign.FilePath = null;
                                }
                                ctx.FileData = null;
                                //#endregion
                                setSignaturePositionsConsoleLog("ConfigCompletition", ctx);
                                if (customLogger != null)
                                    customLogger.info("CallEpkConfigCompletition");
                                this.epkConfigCompletition({ cnt: cnt, def: def, guid: guid, signConfig: ctx, ixp: config.Ixp, ixb: config.Ixb });
                            }

                        });

                    })
              
            }

            return def.promise();
        }


        private epkConfigCompletition(opt: IEpkConfigCompletition) {
            this.server.call("EpkConfigCompletition", {
                Guid: opt.guid,
                SignConfig: opt.signConfig,
            })
                .then((completeConfig) => {
                    opt.def.resolve(completeConfig);
            }, (reason) => {
                var responseText = handleException(reason);
                opt.def.reject({ reason: responseText, handled: false, type: EReasonType.serverError }).promise();
            });
        }

        /** v případě obraz a výskytu vizuálních podpisů, přeskočím umísťování */
        private validateSignaturePositions(config: Gordic.Wfl.Interface.GWflSignCreateConfig) {
            var returnValue = false;
            if (config != null) {
                if (config.ElDocumentType != null) {
                    var count = 0;
                    //if (config.ElDocumentType === Gordic.Wfl.Interface.TypElpEpxEnum.Obraz) {
                        if (config.VisualSignConfig != null && config.VisualSignConfig.SignaturePositions != null && config.VisualSignConfig.SignaturePositions.length > 0) {
                            count = config.VisualSignConfig.SignaturePositions.length;
                            returnValue = true;
                        }
                    //}
                    console.log(String.Format("validateSignaturePositions - type:{0}, count:{1}.", config.ElDocumentType, count));
                }
                else
                    console.log("validateSignaturePositions - config.ElDocumentType is undefined.");
            }
            else
                console.log("validateSignaturePositions - config is undefined.");
            return returnValue;
        } 


    }

    //#endregion


}